import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from '../../actions';

import presenter from './presenter';

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = {
  showNotify: actions.showNotify,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(presenter);
